import Vue from 'vue'
import App from './App.vue'
import {store} from './store/store'
import Print from 'vue-print-nb'

Vue.use(Print)
Vue.config.productionTip = false

new Vue({
  store,
  render: function (h) { return h(App) },
}).$mount('#app')
